module.exports = __webpack_public_path__ + "img/no-data-qq.8213535c.png";